import React from "react"
import styled from "styled-components"
import Layout from "../../layout"
import Img from "gatsby-image"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Settings } from "../../../styles/theme"
import { graphql, Link } from "gatsby"
import groupby from "lodash.groupby"
import samplesize from "lodash.samplesize"
import { Grid } from "../../atoms/grid"

const NewsbyteTemplateStyled = styled.div`
  position: relative;
  padding-top: 15rem;
  h1 {
    color: ${Settings.primaryColor};
    margin-bottom: 0.5rem;
  }
  .meta-data {
    font-size: 1.2rem;
    text-transform: uppercase;
    opacity: 0.7;
    margin-top: 0;
    margin-bottom: 2rem;
    > b {
      color: ${Settings.primaryColor};
    }
  }
  .content {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  .more {
    margin-bottom: 2rem;
    a {
      text-decoration: none;
      font-size: 1.2rem;
      color: ${Settings.secondaryColor};
    }
  }
`

const ImageStyle = styled.div`
  .gatsby-image-wrapper {
    img {
      height: 100%;
    }
  }
`

class NewsbyteTemplate extends React.Component {
  findNext(key, obj) {
    const keys = Object.keys(obj)
    return keys[(keys.indexOf(key) + 1) % keys.length]
  }

  findPrev(key, obj) {
    const keys = Object.keys(obj)
    return keys[(keys.indexOf(key) - 1) % keys.length]
  }

  constructor(props) {
    super(props)
    const newsbytes = groupby(
      props.data.allContentfulNewsbyte.edges,
      rel => rel.node.title
    )
    const next = this.findNext(
      this.props.data.contentfulNewsbyte.title,
      newsbytes
    )
    const prev = this.findPrev(
      this.props.data.contentfulNewsbyte.title,
      newsbytes
    )
    let nextSlug = undefined
    let prevSlug = undefined
    if (next !== undefined) {
      nextSlug = next
        .replace(/\s+/g, "-")
        .replace(/[!@#$%^&*?]/g, "")
        .toLowerCase()
    }
    if (prev !== undefined) {
      prevSlug = prev
        .replace(/\s+/g, "-")
        .replace(/[!@#$%^&*?]/g, "")
        .toLowerCase()
    }
    const readMore = samplesize(newsbytes, 3)
    this.state = {
      newsbytes: newsbytes,
      nextSlug: nextSlug,
      prevSlug: prevSlug,
      readMore: readMore,
    }
  }

  render() {
    console.log(this.state.readMore)
    return (
      <Layout>
        <NewsbyteTemplateStyled>
          <div className="constraint content">
            <h1>{this.props.data.contentfulNewsbyte.title}</h1>
            <p className="meta-data">
              {this.props.data.contentfulNewsbyte.newsbyte_category ? (
                <span>
                  <b>
                    {
                      this.props.data.contentfulNewsbyte.newsbyte_category[0]
                        .title
                    }
                  </b>
                  {" | "}
                </span>
              ) : (
                ""
              )}
              {this.props.data.contentfulNewsbyte.publishedDate}
            </p>
            {this.props.data.contentfulNewsbyte.banner ? (
              <Img fluid={this.props.data.contentfulNewsbyte.banner.fluid} />
            ) : (
              ""
            )}
            {this.props.data.contentfulNewsbyte.content
              ? documentToReactComponents(
                  this.props.data.contentfulNewsbyte.content.json
                )
              : ""}
            <ImageStyle
              className="constraint"
              style={{ padding: "2rem 0 3rem" }}
            >
              {this.props.data.contentfulNewsbyte.adspace ? (
                this.props.data.contentfulNewsbyte.adspace.images ? (
                  <Img
                    fluid={
                      this.props.data.contentfulNewsbyte.adspace.images[0].fluid
                    }
                    style={{
                      maxWidth: "728px",
                      overflow: "hidden",
                      margin: "1rem auto",
                    }}
                  />
                ) : (
                  <Img
                    fluid={this.props.data.adspace2.childImageSharp.fluid}
                    style={{
                      maxWidth: "728px",
                      overflow: "hidden",
                      margin: "1rem auto",
                    }}
                  />
                )
              ) : (
                <Img
                  fluid={this.props.data.adspace2.childImageSharp.fluid}
                  style={{
                    maxWidth: "728px",
                    overflow: "hidden",
                    margin: "1rem auto",
                  }}
                />
              )}
            </ImageStyle>
          </div>
          <div className="more constraint">
            <Grid unstack>
              <div>
                {this.state.prevSlug !== undefined ? (
                  <Link to={"/newsbyte/" + this.state.prevSlug}>
                    {"< PREV"}
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <div style={{ textAlign: "right" }}>
                {this.state.nextSlug !== undefined ? (
                  <Link to={"/newsbyte/" + this.state.nextSlug}>
                    {"NEXT >"}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </Grid>
          </div>
          <div className="constraint">
            <h3 style={{ color: Settings.primaryColor, marginBottom: 0 }}>
              MORE ARTICLES
            </h3>
            <hr style={{ borderColor: Settings.primaryColor }} />
            <Grid>
              {this.state.readMore.map((newsbit, i) => (
                <div key={i}>
                  <Link
                    to={
                      "/newsbyte/" +
                      newsbit[0].node.title
                        .replace(/\s+/g, "-")
                        .replace(/[!@#$%^&*?]/g, "")
                        .toLowerCase()
                    }
                    style={{ textDecoration: "none" }}
                  >
                    <div style={{ padding: "1rem" }}>
                      <Img fluid={newsbit[0].node.banner.fluid} />
                      <h4
                        style={{
                          color: Settings.greyColor,
                          fontWeight: "700",
                        }}
                      >
                        {newsbit[0].node.title}
                      </h4>
                      <p
                        style={{
                          color: Settings.primaryColor,
                          fontWeight: "700",
                          margin: "0",
                        }}
                      >
                        {newsbit[0].node.newsbyte_category
                          ? newsbit[0].node.newsbyte_category[0].title
                          : ""}
                      </p>
                      <p
                        style={{
                          color: Settings.greyColor,
                          opacity: "0.8",
                          margin: "0",
                        }}
                      >
                        {newsbit[0].node.publishedDate}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </Grid>
          </div>
        </NewsbyteTemplateStyled>
      </Layout>
    )
  }
}

export default NewsbyteTemplate

export const query = graphql`
  query($id: String!) {
    adspace2: file(relativePath: { eq: "default_ad.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allContentfulNewsbyte {
      edges {
        node {
          title
          banner {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
          newsbyte_category {
            title
          }
          publishedDate(formatString: "DD MMMM YYYY")
        }
      }
    }
    contentfulNewsbyte(id: { eq: $id }) {
      id
      title
      newsbyte_category {
        title
      }
      banner {
        fluid {
          ...GatsbyContentfulFluid
        }
      }
      publishedDate(formatString: "DD MMMM YYYY")
      content {
        json
      }
      adspace {
        images {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
`
